import { render, staticRenderFns } from "./ShippingDetail.vue?vue&type=template&id=20da5a42&scoped=true&"
import script from "./ShippingDetail.vue?vue&type=script&lang=js&"
export * from "./ShippingDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShippingDetail.vue?vue&type=style&index=0&id=20da5a42&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20da5a42",
  null
  
)

export default component.exports